import { graphql } from 'gatsby';
import Page from 'gatsby-theme-pages/src/layouts/page';

export const pageQuery = graphql`
  query PDVWithWpProductsStrapiPageById($id: String!, $products: [Int] = []) {
    products: allWpSimpleProduct(filter: {
      status: { eq: "publish" }
      databaseId: { in: $products }
    }) {
      nodes {
        id
        databaseId
        name
        ... on WpSimpleProduct {
          uri
          price
          salePrice
          regularPrice
        }
        image {
          filename
          altText
          gatsbyImage(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 600
            height: 600
            cropFocus: CENTER
          )
        }
      }
    }

    page: strapiPagesPages(id: { eq: $id }) {
      id
      slug
      meta {
        pageTitle
        metaTitle
        metaDescription
        noindex
        metaImage {
          src: url
          height
          width
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: FIXED
                width: 400
                quality: 80
              )
            }
          }
        }
      }

      disableBlocks
      blocks: components {
        ...Blocks
      }

      ...PagesPage
      pagebuilderSectionsBeforeContent {
        ...PagebuilderSections
      }
      pagebuilderSectionsAfterContent {
        ...PagebuilderSections
      }
    }
  }
`;

export default Page;
